@if (currentLecture) {
  <app-content-shell [contentId]="currentLecture?.content_id" [settings]="course?.settings" (settingsChanged)="updateSettings($event)">
    <app-content-display-card [contentID]="currentLecture.content_id" [settings]="course?.settings" (updateSettings)="updateSettings($event)">
      <ng-template #header>
        @if (!isReader()) {
          <app-audio-recorder
            [params]="chunk"
            [showAudioButton]="true"
            [contentID]="currentLecture.content_id"
            [origin]="'note'"
            [showTranscribeButton]="true"
            [compact]="isCompact()"
            (click)="contentStateService.pauseAudio()"
          />
        }
      </ng-template>
      <ng-template #headerActions>
        <app-float-edit-menu type="course" [course]="course" [contentID]="currentLecture.content_id" [aiAssistantDisplay]="'icon'" [searchDisplay]="'icon'" [syncContentDisplay]="'icon'" />
      </ng-template>
      <ng-template #body>
        @if (canViewCourse) {
          <div>
            @if (vue == 'text') {
              <app-content
                [readMode]="'true'"
                [course]="course"
                [courseID]="course._id"
                [section]="currentSection"
                [lecture]="currentLecture"
                [contentID]="currentLecture.content_id"
                [contentName]="currentLecture.actualName"
              />
            }
          </div>
        } @else {
          <div class="cannotViewThisCourse">
            @if (courseToRequest) {
              <div>
                <div id="cannotViewMessage">
                  <a routerLink="/knowledge">
                    <img src="assets/creatives/logo-w140.png" alt="logo" width="300px" />
                  </a>
                  <h3>{{ 'Global.NoAccessToThisContent' | translate }}</h3>
                  <a routerLink="/knowledge">{{ 'Global.GoToHomePage' | translate }}</a>
                </div>
                <div id="requestAccess">
                  @if (!requestIsOngoing(courseToRequest._id)) {
                    <mat-form-field appearance="fill">
                      <mat-label>{{ 'Global.Recipient' | translate }}</mat-label>
                      <mat-select [(value)]="courseToRequest.approverID">
                        @for (user of courseToRequest.admins; track user) {
                          <mat-option [value]="user.id">
                            {{ user.firstName + ' ' + user.lastName }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  }
                  @if (!requestIsOngoing(courseToRequest._id)) {
                    <button mat-flat-button color="primary" [disabled]="loading || !courseToRequest.approverID" (click)="sendCourseRequest(courseToRequest._id, courseToRequest.approverID)">
                      {{ 'Global.RequestAccess' | translate }}
                    </button>
                  }
                  @if (requestIsOngoing(courseToRequest._id)) {
                    <div id="cancelAccessRequest">
                      <mat-label>{{ 'Global.PendingRequest' | translate }}</mat-label>
                      <button mat-flat-button color="warn" [disabled]="loading" (click)="cancelRequest(courseToRequest._id)">
                        {{ 'Global.CancelRequest' | translate }}
                      </button>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        }
      </ng-template>
    </app-content-display-card>
  </app-content-shell>
}
